<template>
  <div>
    <div class="pageTitleController">
      <img src="@/assets/img/7.png" />
      <div :title="uuid" class="marginLeft15">企业信息</div>
    </div>
    <!--经销（代理）商信息填写第一步-->
    <Step
      v-if="savetype === 'dailishang'"
      class="marginTop20"
      :list="[
        {
          name: '经销（代理）商信息填写',
          act: true,
          error: one_status,
          msg: one_msg
        },
        {
          name: '生产厂商信息填写',
          act: false,
          error: two_status,
          msg: two_msg
        },
        {
          name: '产品信息填写',
          act: false,
          error: three_status,
          msg: three_msg
        },
        { name: '提交审核', act: false }
      ]"
      @back="back"
    ></Step>
    <!--经销（代理）商信息填写第二部-->
    <Step
      v-if="savetype === 'dailishang2'"
      class="marginTop20"
      :list="[
        {
          name: '经销（代理）商信息填写',
          act: true,
          error: one_status,
          msg: one_msg
        },
        {
          name: '生产厂商信息填写',
          act: true,
          error: two_status,
          msg: two_msg
        },
        {
          name: '产品信息填写',
          act: false,
          error: three_status,
          msg: three_msg
        },
        { name: '提交审核', act: false }
      ]"
      @back="back"
    ></Step>
    <!--生产商信息填写第一步-->
    <Step
      v-if="savetype === 'shenchanshang'"
      class="marginTop20"
      :list="[
        {
          name: '生产厂商信息填写',
          act: true,
          error: two_status,
          msg: two_msg
        },
        {
          name: '产品信息填写',
          act: false,
          error: three_status,
          msg: three_msg
        },
        { name: '提交审核', act: false }
      ]"
      @back="back"
    ></Step>

    <!--下面是显示详情-->
    <!--是代理商并且是通过审核状态的时候直接显示不可修改的详情-->
    <div
      v-if="savetype === 'dailishang' && info && info.profile_step === 2"
      class="marginTop20"
    >
      <Accordion :title="`${infoForm.company_name}-资料详情`" :show="true">
        <div class="componyInfoMainController">
          <!--审核中-->
          <div v-if="info && info.profile_step === 4">
            <!--审核状态-->
            <div class="shenheInfoController">
              <div class="shenheTitle">
                审核信息
              </div>
              <div class="shenheInfo">
                <img class="statusInfo" src="@/assets/img/lan.png" />
                <div class="shenheCon">
                  <div class="shenheTi">
                    您的资料正在审核中，请耐心等待
                  </div>
                  <div class="shenheDes">
                    如有疑问请联系
                    <span class="tel">
                      0871-68183040 15887247294
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!--审核状态-->
            <div class="shenhezhaungtai marginTop20">
              <div class="zhaungtaiTitle">审核状态</div>
              <div class="zhaungtaiInfo tel">审核中</div>
            </div>
          </div>
          <!--审核成功-->
          <div v-if="info && info.profile_step === 2">
            <!--审核状态-->
            <div class="shenheInfoController">
              <div class="shenheTitle">
                审核信息
              </div>
              <div class="shenheInfo">
                <img class="statusInfo" src="@/assets/img/gou.png" />
                <div class="shenheCon">
                  <div class="shenheTi">
                    恭喜
                  </div>
                  <div class="shenheDes">
                    您的资料已通过审核
                  </div>
                </div>
              </div>
            </div>
            <!--审核状态-->
            <div class="shenhezhaungtai marginTop20">
              <div class="zhaungtaiTitle">审核状态</div>
              <div style="color:#00a405;" class="zhaungtaiInfo tel">
                审核通过
              </div>
            </div>
          </div>
          <!--审核失败-->
          <div v-if="info && info.profile_step === 3">
            <!--审核状态-->
            <div class="shenheInfoController">
              <div class="shenheTitle">
                审核信息
              </div>
              <div class="shenheInfo">
                <img class="statusInfo" src="@/assets/img/cha.png" />
                <div class="shenheCon">
                  <div class="shenheTi">
                    抱歉您的资料未通过初审，请求改后重新提交
                  </div>
                  <div class="shenheDes">
                    {{ info.checkmark }}
                  </div>
                </div>
              </div>
            </div>
            <!--审核状态-->
            <div class="shenhezhaungtai marginTop20">
              <div class="zhaungtaiTitle">审核状态</div>
              <div style="color:#ed4014;" class="zhaungtaiInfo tel">
                返回修改
              </div>
            </div>
          </div>

          <!--第一个区域-->
          <div class="componyInfoController marginTop20">
            <div class="aCompony">
              <div class="titles">企业名称</div>
              <div class="des marginTop20">{{ infoForm.company_name }}</div>
            </div>
            <div class="aCompony">
              <div class="titles">企业类型</div>
              <div class="des marginTop20">
                {{ showComponytype }}
              </div>
            </div>
            <div class="aCompony">
              <div class="titles">统一社会信用代码</div>
              <div class="des marginTop20">{{ infoForm.social_code }}</div>
            </div>
            <div class="aCompony">
              <div class="titles">注册资金（万元）</div>
              <div class="des marginTop20">{{ infoForm.reg_capital }}</div>
            </div>
            <div class="aCompony">
              <div class="titles">法定代表人</div>
              <div class="des marginTop20">{{ infoForm.legal_name }}</div>
            </div>
            <div class="aCompony">
              <div class="titles">法定代表人联系电话</div>
              <div class="des marginTop20">{{ infoForm.legal_tel }}</div>
            </div>
            <div class="aCompony">
              <div class="titles">企业注册地址</div>
              <div class="des marginTop20">
                <div class="flexAre">
                  <Areselect :onlyshow="true" v-model="areCodeList"></Areselect>
                  {{ infoForm.register_address }}
                </div>
              </div>
            </div>
            <div v-if="yinyezhizhao[0]" class="aCompony">
              <div class="titles">营业执照（彩色扫描件）</div>
              <div class="des marginTop20">
                <a
                  :href="yinyezhizhao[0].viewurl"
                  target="_blank"
                  style="color:#00B1FF;"
                >
                  营业执照（彩色扫描件）.JPG
                </a>
              </div>
            </div>
          </div>
          <div class="lines"></div>
          <!--第二个区域-->
          <div class="componyInfoController">
            <div class="aCompony">
              <div class="titles">经办人</div>
              <div class="des marginTop20">{{ infoForm.contact_person }}</div>
            </div>
            <div class="aCompony">
              <div class="titles">经办人电话</div>
              <div class="des marginTop20">{{ infoForm.contact_tel }}</div>
            </div>
            <div class="aCompony">
              <div class="titles">通信地址</div>
              <div class="des marginTop20">{{ infoForm.contact_address }}</div>
            </div>
          </div>
        </div>
      </Accordion>
    </div>
    <!--表单详情页-->
    <div
      v-else-if="
        savetype === 'dailishang' ||
          ((savetype === 'dailishang2' || savetype === 'shenchanshang') &&
            li.length === 0)
      "
    >
      <Plan :title="`填写${shoeName}资质信息`" class="marginTop20">
        <div class="total">
          <div class="item">
            <div class="titleOverAll"><span class="red">*</span>企业名称</div>
            <el-input
              v-model="infoForm.company_name"
              placeholder="请填写企业名称"
              class="width320"
            ></el-input>
          </div>
          <div class="item marginLeft40">
            <div class="titleOverAll"><span class="red">*</span>企业类型</div>
            <el-select
              v-model="infoForm.company_cate"
              placeholder="请选择企业类型"
              class="width320"
            >
              <el-option
                v-for="(val, ind) in fenlei"
                :key="ind"
                :label="val.name"
                :value="val.id"
              ></el-option>
            </el-select>
          </div>
          <div class="item marginLeft40">
            <div class="titleOverAll">
              <span class="red">*</span>统一社会信用代码
            </div>
            <el-input
              v-model="infoForm.social_code"
              placeholder="请填写统一社会信用代码"
              class="width320"
            ></el-input>
          </div>
        </div>
        <div class="total marginTop40">
          <div class="item">
            <div class="titleOverAll">
              <span class="red">*</span>注册资金（万元）
            </div>
            <el-input
              type="number"
              v-model="infoForm.reg_capital"
              placeholder="请填写注册资金（万元），例如：100"
              class="width320"
            ></el-input>
          </div>
          <div class="item marginLeft40">
            <div class="titleOverAll"><span class="red">*</span>法定代表人</div>
            <el-input
              v-model="infoForm.legal_name"
              placeholder="请填写法定代表人"
              class="width320"
            ></el-input>
          </div>
          <div class="item marginLeft40">
            <div class="titleOverAll">
              <span class="red">*</span>法定代表人联系电话
            </div>
            <el-input
              v-model="infoForm.legal_tel"
              placeholder="请填写电话"
              class="width320"
            ></el-input>
          </div>
        </div>
        <div class="total marginTop40">
          <div class="item">
            <div class="titleOverAll">
              <span class="red">*</span>企业注册地址
            </div>
            <div class="flexAre">
              <Areselect v-model="areCodeList"></Areselect>
              <el-input
                v-model="infoForm.register_address"
                class="width320 marginLeft40"
                placeholder="请填写企业详细注册地址"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="total marginTop40">
          <div class="titleOverAll" style="flex:1;">
            <span class="red">*</span>营业执照（彩色扫描件）
          </div>
        </div>
        <div class="total marginTop40">
          <div style="flex:1;display:flex;">
            <Up :length="1" v-model="yinyezhizhao" title="点击上传"></Up>
            <div v-if="yinyezhizhao.length === 1" class="upShowController">
              <el-image
                :preview-src-list="[yinyezhizhao[0].viewurl]"
                class="upCoerImg"
                :src="yinyezhizhao[0].viewurl"
              />
              <i @click="yinyezhizhao = []" class="el-icon-delete del"></i>
            </div>
            <div slot="tip" class="el-upload__tip marginLeft10">
              （文件支持多种格式上传，包括png/jpg/pdf/doc，大小不超过4M）
            </div>
          </div>
        </div>
      </Plan>
      <Plan :title="`${shoeName}通讯信息`" class="marginTop20">
        <div class="total marginTop40">
          <!-- <div class="item" v-if="false">
          <div class="ttitleOverAll"><span class="red">*</span>联系人</div>
          <el-input
            v-model="infoForm.contact_person"
            placeholder="请填写联系人"
            class="width320"
          ></el-input>
        </div> -->

          <!-- 经办人输入框 -->
          <div class="item">
            <div class="titleOverAll"><span class="red">*</span>经办人</div>
            <el-input
              v-model="infoForm.contact_person"
              placeholder="请填写经办人"
              class="width320"
            ></el-input>
          </div>
          <!-- 完 -->

          <!-- <div class="item marginLeft40" v-if="false">
          <div class="titleOverAll"><span class="red">*</span>联系人电话</div>
          <el-input placeholder="请填写联系人电话" class="width320"></el-input>
        </div> -->

          <!-- 经办人电话输入框 -->
          <div class="item marginLeft40">
            <div class="titleOverAll"><span class="red">*</span>经办人电话</div>
            <el-input
              v-model="infoForm.contact_tel"
              placeholder="请填写经办人联系电话"
              class="width320"
            ></el-input>
          </div>
          <!-- 完 -->

          <div class="item marginLeft40">
            <div class="titleOverAll"><span class="red">*</span>通信地址</div>
            <el-input
              v-model="infoForm.contact_address"
              placeholder="请填写联系地址"
              class="width320"
            ></el-input>
          </div>
        </div>
      </Plan>
    </div>
    <!--生产厂商模式，如果列表不是空的就直接显示列表选择-->
    <div v-else>
      <Plan class="marginTop20" title="选择产商企业资料">
        <div class="yuanLouKongBtn" @click="jumpToAddShenchang()">
          增加新生产商
        </div>
        <el-table :data="li" style="width: 100%">
          <el-table-column prop="company_name" label="企业名称">
            <template slot-scope="scope">
              <span
                class="el-icon-check"
                style="color:red;"
                v-if="parseInt(id) === scope.row.id"
              ></span>
              {{ scope.row.company_name }}
            </template>
          </el-table-column>
          <el-table-column prop="showComponytype" label="企业类型">
          </el-table-column>
          <el-table-column prop="contact_person" label="联系人">
          </el-table-column>
          <el-table-column prop="contact_tel" label="联系电话">
          </el-table-column>
          <el-table-column prop="contact_address" label="联系地址">
          </el-table-column>
          <el-table-column prop="profile_step" label="审核状态">
            <template slot-scope="scope">
              <span
                style="color:blue;"
                v-if="parseInt(scope.row.profile_step) === 5"
              >
                未提交
              </span>
              <span
                style="color:gree;"
                v-if="parseInt(scope.row.profile_step) === 2"
              >
                已通过
              </span>
              <span
                style="color:blue;"
                v-if="parseInt(scope.row.profile_step) === 4"
              >
                待审核
              </span>
              <span
                style="color:red;"
                v-if="parseInt(scope.row.profile_step) === 3"
              >
                驳回
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span
                style="cursor: pointer;"
                @click="selectShenchanchangshang(scope.row.id)"
              >
                选择
              </span>
              <span
                v-if="parseInt(scope.row.profile_step) === 5"
                style="cursor: pointer;"
                @click="jumpToAddShenchang(scope.row.id)"
              >
                <span>编辑</span>
              </span>
              <span
                v-else-if="parseInt(scope.row.profile_step) === 3"
                style="cursor: pointer;"
                @click="jumpToAddShenchang(scope.row.id)"
              >
                <span>重新提交</span>
              </span>
              <span
                v-else
                style="cursor: pointer;"
                @click="jumpToAddShenchang(scope.row.id, true)"
              >
                <span>查看</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </Plan>
    </div>

    <!-- 确定按钮 -->
    <div v-if="savetype === null" class="flexTextCenter">
      <div @click="sub('save')" class="saveBtnController">保存</div>
      <div @click="sub('submit')" class="subBtnController marginLeft15">
        提交
      </div>
    </div>
    <!--下一步按钮-->
    <div v-else class="flexTextCenter">
      <div @click="next" class="subBtnController marginLeft15">
        下一步
      </div>
    </div>
  </div>
</template>
<script>
import Plan from "@/components/Plan.vue";
import Up from "@/components/Up.vue";
import Api from "@/plugins/axios.js";
import { Loading } from "element-ui";
import Step from "@/components/Step.vue";
import Areselect from "@/components/Areselect.vue";
import Accordion from "@/components/Accordion.vue";
export default {
  components: {
    Accordion,
    Areselect,
    Step,
    Plan,
    Up
  },
  data() {
    return {
      id: null, // 当前选中的生产厂商ID
      li: [], // 生产厂商信息列表
      save: null, // 是否是修改模式，如果是修改模式这里的值是（save）
      uuid: null, // 上一步的UUID存储
      shoeName: "企业", // 当前显示的是企业还是经销（代理）商还是供应商
      savetype: null, // 存储模式（此处主要对应现在是不是产品登记那边跳转过来的，然后还要考虑是经销（代理）商还是生产厂商）
      fenlei: [], // 企业信息分类
      info: null, // 全部详细信息
      // 显示企业类型
      showComponytype: null,
      // 三级地址下拉
      areCodeList: [],
      // 提交的表单信息
      infoForm: {
        company_name: "", // 企业名称
        company_cate: "", // 企业分类
        social_code: "", // 统一社会信用代码
        reg_capital: "", // 注册资本
        legal_name: "", // 法定代表人
        legal_tel: "", // 电话
        register_address: "", // 注册地址
        contact_person: "", // 联系人
        contact_tel: "", // 联系人电话
        contact_address: "" // 联系地址
      },
      yinyezhizhao: [], // 营业执照
      weituoshu: [], // 委托书
      // 下面是控制顶部进度条颜颜色的变量
      one_status: false,
      one_msg: false,
      two_status: false,
      two_msg: false,
      three_status: false,
      three_msg: false
    };
  },
  async mounted() {
    if (this.$route.query.uuid) {
      this.uuid = this.$route.query.uuid;
      // 开始获得产品信息
      const info = await Api.infodetail(
        this.$store.state.token,
        this.$route.query.uuid
      );

      // 下面的逻辑是来判断步骤条的显示状态和文字的
      if (info.one_status) {
        this.one_status = true;
        this.one_msg = "此信息需要修改";
      }
      if (info.two_status) {
        this.two_status = true;
        this.two_msg = "此信息需要修改";
      }
      if (info.three_status) {
        this.three_status = true;
        this.three_msg = "此信息需要修改";
      }
    }
    if (this.$route.query.save) {
      this.save = this.$route.query.save;
    }
    if (this.$route.query.id) {
      this.id = parseInt(this.$route.query.id);
    }
    await this.init();
    await this.getList();
  },
  methods: {
    // 跳转到新增生产厂商
    jumpToAddShenchang(id, show) {
      if (!id) {
        id = null;
        this.id = null;
        this.li = [];
      } else {
        if (show) {
          this.$router.push({
            query: {
              profile_step: 5,
              uuid: id,
              back: 1, // 点确定就返回了
              type: "production"
            },
            name: "AgentInfoShow"
          });
        } else {
          this.$router.push({
            query: {
              profile_step: 5,
              uuid: id,
              back: 1, // 点确定就返回了
              type: "production"
            },
            name: "AgentInfo"
          });
        }
      }
    },
    // 获得生产厂商信息列表
    async getList() {
      const that = this;
      const re = await Api.agentLi(this.$store.state.token, 2, this.id);
      this.li = re.data.map(function(e) {
        // 显示企业类型
        e.showComponytype = null;
        for (let index = 0; index < that.fenlei.length; index++) {
          const element = that.fenlei[index];
          // console.log(parseInt(info.company_cate), parseInt(element.id));
          if (parseInt(e.company_cate) === parseInt(element.id)) {
            console.log(element);
            e.showComponytype = element.name;
          }
        }
        // 地址下拉
        let arr = [];
        if (e.province_code) {
          arr[0] = e.province_code;
        }
        if (e.city_code) {
          arr[1] = e.city_code;
        }
        if (e.area_code) {
          arr[2] = e.area_code;
        }
        e.areCodeList = arr;
        // 营业执照显示
        e.yinyezhizhao = [];
        if (e.business_license) {
          e.yinyezhizhao = [
            {
              name: "",
              url: e.business_license,
              viewurl: Api.domain + e.business_license
            }
          ];
        }
        return e;
      });
      // 如果列表是空的，为了防止出现错误重置一下ID的记录
      if (this.li.length === 0) {
        this.id = null;
      }
    },
    // 初始化
    async init() {
      const loadingInstance = Loading.service({ fullscreen: true });

      // 企业分类
      const li = await Api.getQyFl("business_class", 1);
      this.fenlei = li;

      // 企业信息获得
      // 判断是不是经销（代理）商
      let info = null;
      if (this.$route.query.savetype === "dailishang2") {
        // 切换显示的角色
        this.shoeName = "生产厂商";
        // 经销（代理）商信息获得
        info = await Api.userinfo(this.$store.state.token, true);
      } else {
        // 切换显示的角色
        if (this.$route.query.savetype === "shenchanshang") {
          this.shoeName = "生产厂商";
        } else if (this.$route.query.savetype === "dailishang") {
          this.shoeName = "经销（代理）商";
        }
        // 获得自己的用户信息
        info = await Api.userinfo(this.$store.state.token);
      }
      this.info = info;
      // 判断是否跳转详情页，如果save的参数值是save,就不跳转
      if (
        info !== null &&
        info.profile_step !== 1 &&
        this.$route.query.save !== "save" // 如果不是修改模式则跳转到审核详情页
      ) {
        this.$router.push({
          name: "detail"
        });
      }
      // 判断当前的修改模式
      if (this.$route.query.savetype) {
        this.savetype = this.$route.query.savetype;
      }

      // 处理三级下拉选择器
      if (info) {
        let arr = [];
        if (info.province_code) {
          arr[0] = info.province_code;
        }
        if (info.city_code) {
          arr[1] = info.city_code;
        }
        if (info.area_code) {
          arr[2] = info.area_code;
        }
        this.areCodeList = arr;
        console.log("三级下拉", this.areCodeList);
      } else {
        this.areCodeList = [];
      }

      // 计算显示用的企业类型
      if (info) {
        for (let index = 0; index < this.fenlei.length; index++) {
          const element = this.fenlei[index];
          // console.log(parseInt(info.company_cate), parseInt(element.id));
          if (parseInt(info.company_cate) === parseInt(element.id)) {
            console.log(element);
            this.showComponytype = element.name;
          }
        }
        console.log("显示的企业类型", this.showComponytype);
      }

      this.infoForm = {
        company_name: info ? info.company_name : "", // 企业名称
        company_cate: info ? info.company_cate : "", // 企业分类
        social_code: info ? info.social_code : "", // 统一社会信用代码
        reg_capital: info ? info.reg_capital : "", // 注册资本
        legal_name: info ? info.legal_name : "", // 法定代表人
        legal_tel: info ? info.legal_tel : "", // 电话
        register_address: info ? info.register_address : "", // 注册地址
        contact_person: info ? info.contact_person : "", // 联系人
        contact_tel: info ? info.contact_tel : "", // 联系人电话
        contact_address: info ? info.contact_address : "" // 联系地址
      };
      if (info && info.business_license) {
        this.yinyezhizhao = [
          {
            name: "",
            url: info.business_license,
            viewurl: Api.domain + info.business_license
          }
        ];
      } else {
        this.yinyezhizhao = [];
      }
      if (info && info.agent_attorney) {
        this.weituoshu = [
          {
            name: "",
            url: info.agent_attorney,
            viewurl: Api.domain + info.agent_attorney
          }
        ];
      } else {
        this.weituoshu = [];
      }
      loadingInstance.close();
    },
    // 下一步
    async next() {
      // 生产厂商信息
      if (
        this.savetype === "shenchanshang" ||
        this.savetype === "dailishang2"
      ) {
        if (this.areCodeList.length !== 3 && this.id === null) {
          if (this.id === null) {
            this.$msgbox({
              title: "提示",
              type: "error",
              message: "请选择生产厂商信息"
            });
          } else {
            this.$msgbox({
              title: "提示",
              type: "error",
              message: "请选择企业注册地址"
            });
          }
          return false;
        }
      } else if (this.areCodeList.length !== 3) {
        // 经销商信息填写的时候
        this.$msgbox({
          title: "提示",
          type: "error",
          message: "请选择企业注册地址"
        });
      }

      const loadingInstance = Loading.service({ fullscreen: true });
      const sendData = {
        province_code: this.areCodeList[0], // 省
        city_code: this.areCodeList[1], // 城市
        area_code: this.areCodeList[2], // 区域
        action: "submit",
        ...this.infoForm,
        business_license:
          this.yinyezhizhao.length === 1 ? this.yinyezhizhao[0].url : "",
        agent_attorney: this.weituoshu.length === 1 ? this.weituoshu[0].url : ""
      };

      // 判断当前信息
      if (this.savetype === "dailishang" || this.savetype === "shenchanshang") {
        try {
          Loading.service({ fullscreen: true });
          let reData = null;
          // 代理商信息修改
          if (this.savetype === "dailishang") {
            reData = await Api.saveProfile(this.$store.state.token, sendData);
          }
          if (this.id === null) {
            if (this.savetype === "shenchanshang" && this.li.length === 0) {
              sendData.proifle_step = 5;
              // 生产厂商修改
              reData = await Api.saveProfile(
                this.$store.state.token,
                sendData,
                true
              );
            }
          }

          // 下面开始判断跳转
          if (this.savetype === "shenchanshang") {
            // 跳转的ID计算
            let jumpId = this.id ? this.id : reData ? reData.id : null;
            if (!jumpId) {
              this.$msgbox({
                title: "提示",
                type: "error",
                message: "请选择产商"
              });
              loadingInstance.close();
              return false;
            }

            this.$msgbox({
              title: "提示",
              type: "success",
              message: "操作成功"
            });
            this.$router.push({
              query: {
                id: jumpId,
                uuid: this.uuid,
                savetype: this.savetype,
                save: "save"
              },
              name: "ProductSave"
            });
          } else {
            this.$router.push({
              query: {
                uuid: this.uuid,
                savetype: "dailishang2",
                save: "save"
              },
              name: "ProductInfoSave"
            });
            this.init();
          }
        } catch (error) {
          this.$msgbox({ title: "提示", type: "error", message: error });
        }
      } else if (this.savetype === "dailishang2") {
        try {
          Loading.service({ fullscreen: true });
          let reData = null;
          if (this.id === null) {
            sendData.proifle_step = 5;
            reData = await Api.saveProfile(
              this.$store.state.token,
              sendData,
              true
            );
          }

          // 跳转的ID计算
          let jumpId = this.id ? this.id : reData ? reData.id : null;
          if (!jumpId) {
            this.$msgbox({
              title: "提示",
              type: "error",
              message: "请选择产商"
            });
            loadingInstance.close();
            return false;
          }

          this.$msgbox({
            title: "提示",
            type: "success",
            message: "操作成功"
          });

          this.$router.push({
            query: {
              id: jumpId,
              uuid: this.uuid,
              savetype: this.savetype
            },
            name: "ProductSave"
          });
        } catch (error) {
          this.$msgbox({ title: "提示", type: "error", message: error });
        }
      }
      loadingInstance.close();
    },
    async sub(action) {
      const loadingInstance = Loading.service({ fullscreen: true });
      const sendData = {
        action,
        ...this.infoForm,
        business_license:
          this.yinyezhizhao.length === 1 ? this.yinyezhizhao[0].url : "",
        agent_attorney: this.weituoshu.length === 1 ? this.weituoshu[0].url : ""
      };
      try {
        Loading.service({ fullscreen: true });
        await Api.saveProfile(this.$store.state.token, sendData);
        this.$msgbox({ title: "提示", type: "success", message: "操作成功" });
        if (action === "submit") {
          this.$router.push({
            name: "detail"
          });
        }
      } catch (error) {
        this.$msgbox({ title: "提示", type: "error", message: error });
      }
      loadingInstance.close();
    },
    back() {
      // 下面开始判断跳转
      if (this.savetype === "dailishang2") {
        this.$router.push({
          query: {
            uuid: this.uuid,
            id: this.id,
            savetype: "dailishang",
            save: "save"
          },
          name: "ProductInfoSave"
        });
        this.init();
      } else {
        this.$router.push({
          name: "ProductList"
        });
      }
    },
    // 选中一个生产厂商
    selectShenchanchangshang(id) {
      this.id = id;
    }
  }
};
</script>

<style lang="less" scoped>
// 企业信息显示详情
.componyInfoMainController {
  // 审核详情
  .shenheInfoController {
    .shenheTitle {
      padding: 16px 32px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      opacity: 1;
    }
    // 详情容器
    .shenheInfo {
      border-top: 1px solid rgba(230, 230, 230, 1);
      padding: 24px 32px;
      display: flex;
      .shenheCon {
        margin-left: 20px;
        .shenheTi {
          font-size: 12px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          opacity: 1;
        }
        .shenheDes {
          margin-top: 5px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          opacity: 1;
        }
      }
    }
  }
  // 审核状态
  .shenhezhaungtai {
    padding: 12px 32px;
    display: flex;
    // 状态标题
    .zhaungtaiTitle {
      font-size: 14px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      opacity: 1;
    }
    // 状态详情
    .zhaungtaiInfo {
      margin-left: 30px;
      font-size: 14px;
      font-weight: 400;
      opacity: 1;
    }
  }
  // 蓝色
  .tel {
    color: #00b1ff;
  }
  .shenheInfoController,
  .shenhezhaungtai {
    background-color: #f0f5f7;
    border-radius: 10px;
  }
  // 企业信息显示详情
  .componyInfoController {
    display: flex;
    flex-wrap: wrap;
    .aCompony {
      width: 33%;
      min-width: 33%;
      margin-top: 35px;
      // 标题
      .titles {
        font-size: 12px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        opacity: 1;
      }
      // 描述
      .des {
        font-size: 12px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
        a {
          text-decoration: none;
          color: #00b1ff;
        }
      }
    }
    .aCompony:nth-child(1),
    .aCompony:nth-child(2),
    .aCompony:nth-child(3) {
      margin-top: 0px;
    }
  }
  .btnController {
    text-align: center;
  }
}
.el-upload__tip {
  font-size: 12px;
  font-weight: 400;
  color: rgba(204, 204, 204, 1);
}
//蓝色上传按钮
.el-button {
  width: 120px;
  height: 32px;
  background: #0082a4 !important;
  opacity: 1;
  border-radius: 2px;
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}
.total {
  border-radius: 20px;
  margin-top: 20px;
}
.el-button {
  height: none;
}
.blueBorder {
  width: 200px;
  // height: 40px;
  border: 1px solid rgba(0, 130, 164, 1);
  opacity: 1;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0) !important;
  font-size: 16px;
  font-weight: 400;
  color: rgba(0, 130, 164, 1);
  margin-top: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.noneBorder {
  width: 200px;
  height: 40px;
  border: 1px solid rgba(0, 130, 164, 1);
  opacity: 1;
  border-radius: 20px;
  background: rgba(0, 130, 164, 1) !important;
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  margin-top: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.check {
  justify-content: center;
  align-items: center;
}
.center {
  justify-content: center;
}
.getUp {
  flex: 1;
  display: flex;
}
.flexTextCenter {
  text-align: center;
}
.upShowController {
  position: relative;
  right: 0px;
  top: 0px;
  .del {
    position: absolute;
    top: 0px;
    right: 0px;
    color: red;
    font-size: 22px;
  }
}
.flexAre {
  display: flex;
  align-items: center;
}
</style>
